export default "__VITE_ASSET__Do6NC1wv__"